"use client"

import { RouteErrorBoundary } from "@/components/shared/route-error-boundary"

export default function LoginError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      boundary="app/login/error.tsx"
      title="Login Error"
      description="Something went wrong loading the login page"
      action="home"
    />
  )
}
